import React, { useState, useEffect } from "react";
import NavBar from '../NavBar';
import API_BASE_URL from "../../config";
import bgVideo from "../../Assets/bgvid.mp4";

import {
  Phone,
  Mail,
  MapPin,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

import "../Styles/Contact.css";
import hm01 from "../../Assets/hm01.jpg";
import hm02 from "../../Assets/hm02.jpg";
import hm03 from "../../Assets/hm03.jpg";
import hm04 from "../../Assets/hm04.jpg";

const Contact = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const heroImages = [
    {
      url: hm01,
      title: "Step Into Techstrike",
      subtitle: "Empowering Future Innovators",
    },
    {
      url: hm02,
      title: "Explore Our Modern Facilities",
      subtitle: "A Space Designed for Learning and Growth",
    },
    {
      url: hm03,
      title: "Building Bright Futures at Techstrike",
      subtitle: "A Place Designed for Your Success",
    },
    {
      url: hm04,
      title: "Join Our Community",
      subtitle: "Let’s Build a Brighter Future Together",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + heroImages.length) % heroImages.length
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(`${API_BASE_URL}/api/messages`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        } else {
          alert("❌ " + (data.message || "Something went wrong."));
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        alert("Server error. Please try again later.");
      });
  };

  return (
    <div className="contact-page">
      <video autoPlay loop muted playsInline className="contact-bg-video">
        <source src={bgVideo} type="video/mp4" />
      </video>

      <div className="contact-bg-overlay"></div>

      <NavBar />

      {/* Hero Slider */}
      <div className="hero-slider">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? "active" : ""}`}
          >
            <img src={image.url} alt={image.title} />
          </div>
        ))}

        <div className="hero-overlay">
          <h1>{heroImages[currentSlide].title}</h1>
          <p>{heroImages[currentSlide].subtitle}</p>

        </div>

        <button onClick={prevSlide} className="slider-btn left">
          <ChevronLeft size={24} />
        </button>
        <button onClick={nextSlide} className="slider-btn right">
          <ChevronRight size={24} />
        </button>

        <div className="slider-dots">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={index === currentSlide ? "active" : ""}
            ></button>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-main">
        {/* Left Column */}
        <div className="contact-info">
          <h2>How to Find Us</h2>
          <p>If you have any questions, just fill in the contact form, and we will answer you shortly.</p>
          <br />

          <h3>Contact Information</h3>
          <br />
          <div className="info-item">
            <MapPin size={20} />
            <div>
              <p>CINEC Campus (Pvt) Ltd.</p>
              <p>Millennium Drive, IT Park, Malabe, Sri Lanka</p>
            </div>
          </div>
          <div className="info-item">
            <Phone size={20} />
            <p>Telephone: +94 77 860 2219</p>
          </div>
          <div className="info-item">
            <Mail size={20} />
            <p>E-mail: <a href="mailto:cinectechstrike@gmail.com">cinectechstrike@gmail.com</a></p>
          </div>
          <br />

          <h3>Find Us on Map</h3>
          <iframe
            title="Map showing CINEC Campus"
            src="https://www.google.com/maps?q=CINEC+Campus,+Malabe,+Sri+Lanka&output=embed"
            className="map-frame"
            allowFullScreen
            loading="lazy"
          />
          <div className="map-link">
            <a href="https://www.google.com/maps/place/CINEC+Campus/@6.8954777,79.957928,17z/"
              target="_blank" rel="noopener noreferrer">
              <MapPin size={16} /> View on Google Maps
            </a>
          </div>
        </div>

        {/* Right Column */}
        <div className="contact-form">
          <h2>Get in Touch</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your Name"
                required
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="your.email@example.com"
                required
              />
            </div>

            <textarea
              name="message"
              id="tt"
              value={formData.message}
              onChange={handleInputChange}
              rows="6"
              placeholder="Your message here..."
              required
            ></textarea>

            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>


    </div>
  );
};

export default Contact;
